import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { PersonServices } from "../../../services";
import { IBaseItem } from "../types";
import { useIntl } from "react-intl";
import { Tools } from "../../../misc";

const SelectGender = (props: any) => {
  const [genders, setGenders] = useState<IBaseItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedGender, setSelectedGender] = useState<number>(0);

  const intl = useIntl();

  useEffect(() => {
    (async () => {
      const genderResponse = await PersonServices.GetGenders();

        if (Tools.IsDevelopment()) console.log("Genders Select", genderResponse);

      setGenders(genderResponse);
      setIsLoading(false);
    })();
  }, []);

  const onControlChange = (e: any) => {
    setSelectedGender(parseInt(e.target.value));

    if (props.SuscribedChange) props.SuscribedChange(parseInt(e.target.value));
  };

  return (
    <>
      <Form.Group
        className={`justify-content-center ${props.ClassGroup || ""}`}
      >
        <Form.Label
          className={`font-label-form ${!props.Label ? "d-none" : ""}`}
        >
          {intl.formatMessage({ id: props.Label, defaultMessage: props.Label })}
        </Form.Label>
        {isLoading ? (
          <></>
        ) : (
          <Form.Select
            size="sm"
            disabled={props.Disabled || false}
            onChange={(e: any) => onControlChange(e)}
            key={"select-gender"}
            defaultValue={
              props.DefaultValue && genders.length > 0
                ? props.DefaultValue
                : undefined
            }
          >
            {genders?.map((element: IBaseItem, index: number) => {
              return (
                <option value={element.Id} key={`select-gender-${element.Id}`}>
                  {element.Name}
                </option>
              );
            })}
          </Form.Select>
        )}
      </Form.Group>
    </>
  );
};

export default SelectGender;
